import { z } from 'zod';
import './styles/global.css';

const root = document.getElementById('root');
if (root === null) throw new Error('Crownweald application root is missing.');

// Configure Zod before the browser bundle imports any schema module.  This
// disables its optional eval-based fast path and keeps the production CSP at
// strict `script-src 'self'` without an unsafe-eval exception.
z.config({ jitless: true });
void (async () => {
  const [
    { StrictMode },
    { createRoot },
    { registerSW },
    { App },
    { AppErrorBoundary },
    { installVitePreloadRecovery },
  ] = await Promise.all([
    import('react'),
    import('react-dom/client'),
    import('virtual:pwa-register'),
    import('./App.js'),
    import('./components/AppErrorBoundary.js'),
    import('./preload-recovery.js'),
  ]);
  installVitePreloadRecovery();
  registerSW({
    immediate: true,
    onRegisteredSW(_scriptUrl, registration) {
      if (registration === undefined) return;
      const updateInterval = window.setInterval(() => void registration.update(), 30_000);
      window.addEventListener('pagehide', () => window.clearInterval(updateInterval), { once: true });
    },
  });
  createRoot(root).render(
    <StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </StrictMode>,
  );
})();
